import { MathJaxObject } from "mathjax-full/js/components/startup";
import { FinishEvent } from "@sabyr-dev/mist_core/events";
import { FilterValue } from "@sabyr-dev/mist_core/lib/filter";
import { ContentItem } from "@sabyr-dev/mist_core/model/datasource/item";
import { ListItem } from "@sabyr-dev/mist_core/model/datasource/list";
import { BindRecord } from "@sabyr-dev/mist_core/view/frontend/frontend";
import { Question } from "@sabyr-dev/mist_elibrary/datasource";
import { ElibrarySettingsFrontend } from "@sabyr-dev/mist_elibrary/frontend";
import { SaveEmailEvent, ResendEmailEvent, CheckEmailEvent } from "../../events";

declare global {
	interface Window {
		MathJax: MathJaxObject
	}
}

export class AcademySettingsFrontend extends ElibrarySettingsFrontend {
	getBindSaveEmail(): BindRecord {
		return new BindRecord(
			document.querySelectorAll('.collect-email form'),
			'submit',
			element => new SaveEmailEvent(element),
			true
		);
	}

	getBindPartialResults(): BindRecord {
		return new BindRecord(
			document.querySelectorAll('.collect-email .results'),
			'click',
			element => new FinishEvent(),
			true
		);
	}

	getBindRetryEmail(): BindRecord {
		return new BindRecord(
			document.querySelectorAll('.double-opt-in-notice form'),
			'submit',
			element => new ResendEmailEvent(element),
			true
		);
	}

	getBindCheckEmail(): BindRecord {
		return new BindRecord(
			document.querySelectorAll('.double-opt-in-notice .unlock'),
			'click',
			element => new CheckEmailEvent(element.closest('form.double-opt-in')),
			true
		);
	}

	updateReportEmail(email: string): void {
		const report = document.querySelector<HTMLFormElement>('.modal-dialog form.report');
		report.elements['email'].value = email;
	}

	displayEmailModal(jQuery: JQueryStatic, count: number): void {
		const modal = document.querySelector('.collect-email');
		modal.querySelectorAll('.question-count').forEach(label => {
			label.textContent = `${count}`;
		});
		jQuery(modal).modal('show');
	}

	hideEmailModal(jQuery: JQueryStatic): void {
		const modal = document.querySelector('.collect-email');
		jQuery(modal).modal('hide');
	}

	displayDoubleOptInModal(jQuery: JQueryStatic, email: string): void {
		const doubleOptIn = document.querySelector<HTMLFormElement>('.modal-dialog form.double-opt-in');
		doubleOptIn.elements['email'].value = email;
		jQuery('.double-opt-in-notice').modal('show');
	}

	displayDoubleOptInRetry() {
		const retry = document.querySelector<HTMLElement>('.modal-dialog .retry-message');
		const unlock = document.querySelector<HTMLElement>('.modal-dialog .unlock-message');
		retry.classList.toggle('d-none', false);
		retry.classList.toggle('text-muted', false);
		unlock.classList.toggle('d-none', true);
		setTimeout(() => { retry.classList.add('text-muted'); }, 100);
	}

	displayDoubleOptInUnlock() {
		const retry = document.querySelector<HTMLElement>('.modal-dialog .retry-message');
		const unlock = document.querySelector<HTMLElement>('.modal-dialog .unlock-message');
		unlock.classList.toggle('d-none', false);
		unlock.classList.toggle('text-muted', false);
		retry.classList.toggle('d-none', true);
		setTimeout(() => { unlock.classList.add('text-muted'); }, 100);
	}

	hideDoubleOptInModal(jQuery: JQueryStatic): void {
		jQuery('.double-opt-in-notice').modal('hide');
	}

	displayErrorModal(jQuery: JQueryStatic, url: string, item: ContentItem<Question> | ListItem<Question>, filters: FilterValue[], screenshot: string, errors: (Error | any)[], localStorage: Record<string, any>): void {
		const explanation = document.querySelector<HTMLFormElement>('.report-error .explanation');
		explanation.classList.remove('show');
		switch (item.type) {
			case 'multiplechoice':
				explanation.innerHTML = item.multiplechoice.explanation;
				break;
			case 'multiplecorrect':
				explanation.innerHTML = item.multiplecorrect.explanation;
				break;
			case 'numeric':
				explanation.innerHTML = item.numeric.explanation;
				break;
			case 'cloze':
				explanation.innerHTML = item.cloze.explanation;
				break;
			case 'unknown':
			default:
				explanation.innerHTML = 'Error: Unable to load explanation';
				break;
		}
		window.MathJax.typesetPromise().then(() => {
			super.displayErrorModal(jQuery, url, item, filters, screenshot, errors, localStorage);
		});
	}
}